import { SupportedCurrencies } from 'vopay';
import { useEffect, useState } from 'react';
import { useApi } from '#shared/providers/Api';

export type Balance = {
  AccountBalance: number;
  AvailableFunds: number;
  Currency: SupportedCurrencies;
  PendingFunds: number;
  Reserve: number;
  RollingReserveNSF: number;
  RollingReserveReturns: number;
  RollupAvailableBalance: number | null;
};

// The account's per-currency balances — the transaction filters' currency
// options come from these.
export default function useAccountBalances() {
  const api = useApi();
  const [balances, setBalances] = useState<Balance[]>([]);
  const [fetchingBalances, setFetchingBalances] = useState(false);

  useEffect(() => {
    fetchBalances().catch(() => {
      // Logged by the fetch; the currency filter degrades to "All".
    });
  }, []);

  async function fetchBalances() {
    try {
      setFetchingBalances(true);
      const response = await api.fetchAccountBalances({});

      if (!response.Success) throw new Error(response.ErrorMessage);

      setBalances(
        response.AccountBalances.map((balance) => ({
          AccountBalance: balance.AccountBalance,
          AvailableFunds: balance.AvailableFunds,
          Currency: balance.Currency,
          PendingFunds: balance.PendingFunds,
          Reserve: balance.Reserve,
          RollingReserveNSF: balance.RollingReserveNSF ?? 0,
          RollingReserveReturns: balance.RollingReserveReturns ?? 0,
          RollupAvailableBalance: balance.RollupAvailableBalance ?? null,
        })),
      );
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetchingBalances(false);
    }
  }

  return { fetchingBalances, balances, fetchBalances };
}
